import Cookies from 'js-cookie'
import {Base64} from "js-base64";
import {isMeaningless} from "@/utils/common";

export const GERP_UI = 'gerp_ui';
export const GERP_UI_SECRET = 'gerp_ui_secret';
export const AUTHORIZATION = `Basic ${Base64.encode(GERP_UI + ':' + GERP_UI_SECRET)}`;

export const AUTH_TOKEN = 'gerp-auth-token';
export const AUTH_TENANT = 'gerp-auth-tenant';
export const AUTH_USER_ID = 'gerp-auth-user-id';
export const AUTH_ACCOUNT = 'gerp-auth-account';

export const REGISTER_INFO = 'gerp-register-info';

export function getToken() {
  return Cookies.get(AUTH_TOKEN);
}

export function setToken(token, sevenDaysNoPassword) {
  if(sevenDaysNoPassword){
    return Cookies.set(AUTH_TOKEN, token, {expires:7});
  }else {
    return Cookies.set(AUTH_TOKEN, token);
  }
}

export function removeToken() {
  return Cookies.remove(AUTH_TOKEN);
}

export function removePE() {
  return Cookies.remove('noPE');
}

export function getTenant() {
  return Cookies.get(AUTH_TENANT);
}

export function setTenant(tenant, sevenDaysNoPassword) {
  if(sevenDaysNoPassword){
    return Cookies.set(AUTH_TENANT, tenant, {expires:7});
  }else {
    return Cookies.set(AUTH_TENANT, tenant);
  }
}

export function removeTenant() {
  return Cookies.remove(AUTH_TENANT);
}

export function getUserId() {
  return Cookies.get(AUTH_USER_ID);
}

export function setUserId(userId, sevenDaysNoPassword) {
  if(sevenDaysNoPassword){
    return Cookies.set(AUTH_USER_ID, userId, {expires:7});
  }else {
    return Cookies.set(AUTH_USER_ID, userId);
  }
}

export function removeUserId() {
  return Cookies.remove(AUTH_USER_ID);
}

export function getAccount() {
  return Cookies.get(AUTH_ACCOUNT);
}

export function setAccount(account, sevenDaysNoPassword) {
  if(sevenDaysNoPassword){
    return Cookies.set(AUTH_ACCOUNT, account, {expires:7});
  }else {
    return Cookies.set(AUTH_ACCOUNT, account);
  }
}

export function removeAccount() {
  return Cookies.remove(AUTH_ACCOUNT);
}

export function getRegisterInfo() {
  const registerInfo = Cookies.get(REGISTER_INFO);
  if (isMeaningless(registerInfo)) {
    return null;
  }
  return JSON.parse(registerInfo);
}

export function setRegisterInfo(info) {
  return Cookies.set(REGISTER_INFO, info);
}

export function removeRegisterInfo() {
  return Cookies.remove(REGISTER_INFO);
}
